import React, { useEffect, useState } from "react";
import axios from "../../axios";
import urls from "../../Utils/urls";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import { useAbortController } from "../../hooks/useAbortController";
import FormBox from "../FormBox/FormBox";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { LoadingButton } from "../../Utils/CustomComponent";
import { useSelector } from "react-redux";

const CreateTicket = ({ close, refreshTable }) => {
  const [severityValues, setSeverityValues] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [urgencyOptions, setUrgencyOptions] = useState([]);
  const [categoriesOption, setCategoriesOption] = useState([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSubCategories, setShowSubCategories] = useState(false);
  const accountOptions = useSelector((state) => state.account.accountOptions);
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const createTicketFormSchema = {
    resolver: yupResolver(
      Yup.object().shape({
        subject: Yup.string().required("Subject is mandatory"),
        incident_description: Yup.string().required("Description is mandatory"),
        account: Yup.string().required("Account is mandatory"),
        // department_id: Yup.string().required("Department is mandatory"),
        // category_id: Yup.string().required("Category is mandatory"),
        // ...(showSubCategories && {
        //   sub_category_id: Yup.string().required("Sub-Category is mandatory"),
        // }),
        // severity_id:  Yup.string().required("Severity is mandatory"),
        // urgency_id:  Yup.string().required("Urgency is mandatory"),
      })
    ),
  };
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm(createTicketFormSchema);
  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));
  const { signal } = useAbortController();
  const selectedCategory = watch("category_id");
  const selectedDepartment = watch("department_id");

  useEffect(() => {
    const axiosConfig = {
      headers: {
        Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
      },
    };
    const requestUrls = [
      urls.support.getCreateTicketDropdown("severity"),
      urls.support.getCreateTicketDropdown("department"),
      urls.support.getCreateTicketDropdown("urgency"),
    ];
    Promise.all(
      requestUrls?.map((url) => axios.get(url, axiosConfig, { signal }))
    )
      .then((responses) => {
        const [severityRes, departmentRes, urgencyRes] = responses;
        setSeverityValues(severityRes.data.items);
        setDepartmentOptions(departmentRes.data.items);
        setUrgencyOptions(urgencyRes.data.items);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  const onSubmit = (data) => {
    setLoading(true);
    const id = toast.loading("Creating a new ticket");

    data.user_id = `${userDetails.user_id}`;
    data.contact_email = userDetails.email;
    data.status_id = "1";
    data.role_type = selectedRole;
    data.severity_id = "";
    data.urgency_id = "";
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
      maxBodyLength: Infinity,
    };
    axios
      .post(urls.support.postTicket(), data, { headers })
      .then((response) => {
        close();
        toast.update(id, {
          render: "Ticket Created",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
        refreshTable();
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        toast.update(id, {
          render: "SOME ERROR OCCURED",
          type: "error",
          isLoading: false,
          ...commonToast,
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    if (selectedCategory) {
      setShowSubCategories(false);
      setValue("sub_category_id", null);
      setSubCategoryOptions([]);
      setLoading(true);
      const axiosConfig = {
        headers: {
          Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
        },
      };
      axios
        .get(urls.support.getSubCategories(selectedCategory), axiosConfig)
        .then((response) => {
          if (response.data.items.length > 0) {
            setSubCategoryOptions(response.data.items);
            setShowSubCategories(true);
          } else {
            setShowSubCategories(false);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      setShowSubCategories(false);
      setSubCategoryOptions([]);
    }
  }, [selectedCategory]);
  useEffect(() => {
    if (selectedDepartment) {
      setLoading(true);
      setValue("category_id", null);
      setShowSubCategories(false);
      setCategoriesOption([]);
      const axiosConfig = {
        headers: {
          Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
        },
      };
      axios
        .get(
          urls.support.getCreateTicketCategories(
            "category",
            selectedDepartment
          ),
          axiosConfig
        )
        .then((response) => {
          setCategoriesOption(response.data.items);
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      setValue("category_id", null);
      setCategoriesOption([]);
    }
  }, [selectedDepartment]);

  const ticketFormArr = [
    {
      title: "Subject",
      field: "subject",
      type: "text",
      className: "col-12",
    },
    {
      title: "Description",
      field: "incident_description",
      type: "textarea",
      className: "col-12",
    },
    {
      title: "Account",
      field: "account",
      type: "select",
      options: accountOptions,
      className: "col-12",
      blur: true,
    },
    {
      title: "Department",
      field: "department_id",
      type: "select",
      options: departmentOptions.map((option) => ({
        label: option.product_name,
        value: option.id,
      })),
      className: "col-6",
      blur: true,
    },
    {
      title: "Category",
      field: "category_id",
      type: "select",
      options: categoriesOption.map((option) => ({
        label: option.category_name,
        value: option.id,
      })),
      className: "col-6",
      blur: true,
    },
    {
      title: "Sub-Category",
      field: "sub_category_id",
      type: "select",
      options: subCategoryOptions.map((option) => ({
        label: option.category_name,
        value: option.id,
      })),
      className: `col-12 ${showSubCategories ? "" : "d-none"}`,
      blur: true,
    },
    // {
    //   title: "Severity",
    //   field: "severity_id",
    //   type: "select",
    //   options: severityValues.map((option) => ({
    //     label: option.severity_name,
    //     value: option.id,
    //   })),
    //   className: "col-6",
    // },
    // {
    //   title: "Urgency",
    //   field: "urgency_id",
    //   type: "select",
    //   options: urgencyOptions.map((option) => ({
    //     label: option.urgency_name,
    //     value: option.id,
    //   })),
    //   className: "col-6",
    // },
  ];

  return (
    <div className="mt-2">
      <form className="py-5 bg-white" onSubmit={handleSubmit(onSubmit)}>
        <div className="container">
          <div className="row">
            <div className="col-12 mb-4">
              <FormBox
                options={ticketFormArr}
                register={register}
                watch={watch}
                setValue={setValue}
                errors={errors}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end mt-5">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => close()}
          >
            Cancel
          </button>
          <LoadingButton
            loading={loading}
            disabled={loading}
            type="submit"
            className="btn btn-primary text-white"
            title={"Create Ticket"}
          />
        </div>
      </form>
    </div>
  );
};

export default CreateTicket;
